import React, {FC, useState} from 'react';

import {Skeleton, SkeletonColorSchemesEnum} from '../../../libs/shared/ui/src/components/utility/skeleton';

/*
 * Constants.
 */

const DEFAULT_SKELETON_MIN_WIDTH = 20;
const DEFAULT_SKELETON_MAX_WIDTH = 60;

/*
 * Props.
 */

interface RandomSkeletonProps {
  // Min and max width of the skeleton in %.
  minWidth?: number;
  maxWidth?: number;
  // Height of the skeleton.
  height?: string;
  // Border Radius of the skeleton.
  borderRadius?: string;
  /* Scheme of the skeleton */
  scheme?: SkeletonColorSchemesEnum;
}

/*
 * Component.
 */

export const RandomSkeleton: FC<RandomSkeletonProps> = ({
  minWidth = DEFAULT_SKELETON_MIN_WIDTH,
  maxWidth = DEFAULT_SKELETON_MAX_WIDTH,
  height,
  borderRadius,
  scheme,
}) => {
  const [width] = useState(Math.floor(Math.random() * maxWidth) + minWidth);

  return <Skeleton width={`${width}%`} height={height} borderRadius={borderRadius} scheme={scheme} />;
};
